export default "__VITE_ASSET__CJk5N_g4__"